import {compact} from '@benchling/js-utils';
import React, {useState} from 'react';

import * as analytics from 'analytics/Analytics';
import {NAV_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import BaseSavedSearchModal from 'search/saved-searches/BaseSavedSearchModal';
import {SavedSearch} from 'search/saved-searches/SavedSearchUtil';
import {SearchParams} from 'search/SearchConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';

export interface InsertSearchModalProps {
  searchSection: SearchSection;
  closeModal: () => void;
  submitModal: (savedSearch: SavedSearch) => void;
  onSearch: (searchParams: SearchParams) => void;
  searchParams: SearchParams;
  fileId: string;
}

/** A modal for viewing and managing all Saved Searches. */
export default function InsertSearchModal(props: InsertSearchModalProps): JSX.Element {
  const [submitting, setSubmitting] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');

  // eslint-disable-next-line require-await
  const handleSubmit = async (selectedSearch: SavedSearch): Promise<void> => {
    setSubmitting(true);
    try {
      props.submitModal(selectedSearch);
      analytics.trackEvent(NAV_ANALYTICS_ACTIONS.INSERTED_SAVED_SEARCH, {
        section: selectedSearch.section,
        api_id: selectedSearch.id,
        entry_id: props.fileId,
      });
      props.closeModal();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <BaseSavedSearchModal
      showModalOptions={false}
      showOptionsMenu={false}
      buttons={compact([
        {
          text: 'Cancel',
          cancel: true,
          disabled: submitting,
        },
        {
          text: 'Insert Search',
          submit: true,
          style: ButtonStyle.SECONDARY,
          disabled: submitting || selectedValue === '',
        },
      ])}
      onRequestSubmit={handleSubmit}
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      {...props}
    />
  );
}
